export default {
  title: '安全中心',

  accountSec: '賬號安全',
  loginPwd: '登錄密碼',
  loginPwdDesc: '已設置 · 建議定期更換',
  loginPwdAction: '修改 ›',

  fundPwd: '資金密碼',
  fundPwdUnset: '未設置 · VIPPAY 支付前須設置',
  fundPwdSet: '已設置 · 提現等敏感操作需驗證',
  fundPwdSetup: '設置 ›',
  fundPwdChange: '修改 ›',

  bindPhone: '綁定手機',
  bindPhoneUnset: '未綁定 · 用於驗證碼與找回',
  bindPhoneAction: '綁定 ›',
  bindPhoneChange: '更換 ›',

  bindEmail: '綁定郵箱',
  bindEmailUnset: '未綁定 · 用於安全通知與找回',
  bindEmailAction: '綁定 ›',
  bindEmailChange: '更換 ›',

  devices: '登錄設備',
  deviceCurrent: '本機 · 當前在線',
  deviceLocal: '本機',
  deviceEmpty: '暫無登錄設備',
  deviceLoading: '加載中…',
  kick: '下線',
  kickOk: '設備已下線',

  logs: '安全記錄',
  logEmpty: '暫無安全記錄',
  logLoading: '加載中…',
  logOk: '正常',
  logBlocked: '攔截',
  logUnknown: '安全事件',
  logLocalAction: '本機操作',
  logPwdReset: '重置登錄密碼',
  logReason: {
    bad_password: '密碼錯誤',
    bad_code: '驗證碼錯誤',
    bad_old_password: '原密碼錯誤',
    player_disabled: '賬號已禁用',
    login_restricted: '登錄受限',
    fund_password_mismatch: '資金密碼錯誤',
    fund_password_locked: '資金密碼已鎖定',
  },
  logLoginOk: '登錄成功',
  logLoginFail: '登錄失敗',
  logNewDevice: '新設備登錄',
  logWithdrawSubmit: '提現申請提交',
  logPhoneBound: '綁定手機',
  logPhoneChanged: '更換綁定手機',
  logPwdChanged: '修改登錄密碼',
  logFundSet: '設置資金密碼',
  logFundChanged: '修改資金密碼',
  logFundReset: '重置資金密碼',
  logFundVerifyFail: '資金密碼驗證失敗',
  logEmailBound: '綁定郵箱',
  logEmailChanged: '更換綁定郵箱',
  logDeviceKick: '遠程設備已下線',

  changeLoginPwd: '修改登錄密碼',
  currentPwd: '當前密碼',
  currentPwdPh: '請輸入當前密碼',
  newPwd: '新密碼',
  newPwdPh: '8-64 位,含字母與數字',
  confirmNewPwd: '確認新密碼',
  confirmNewPwdPh: '再次輸入新密碼',
  confirmChange: '確認修改',
  pwdHint: '修改成功後,其他已登錄設備將自動下線',
  pwdOk: '密碼已修改,其他設備已自動下線',
  errPwdOldEmpty: '請輸入當前密碼',
  errPwdRule: '新密碼須為 8-64 位且包含字母與數字',
  errPwdMismatch: '兩次輸入的新密碼不一致',
  errPwdSame: '新密碼不能與當前密碼相同',

  setFundPwd: '設置資金密碼',
  changeFundPwd: '修改資金密碼',
  resetFundPwd: '重置資金密碼',
  currentFundPwd: '當前資金密碼',
  newFundPwd: '新資金密碼',
  confirmFundPwd: '確認新資金密碼',
  fundPwdPh: '6 位數字',
  fundPwdPhHint: '6 位數字,勿與生日/手機號相同',
  fundPwdAgain: '再次輸入',
  forgetFund: '忘記資金密碼?›',
  confirm: '確認',
  fundHint: '資金密碼用於提現、賬戶變更等敏感操作;連續輸錯 5 次將鎖定 2 小時。',
  fundOkSet: '資金密碼已設置',
  fundOkChange: '資金密碼已修改',
  fundOkReset: '資金密碼已重置',
  errFundFormat: '請輸入 6 位數字資金密碼',
  errFundOld: '當前資金密碼不正確',
  errFundSame: '新密碼不能與當前資金密碼相同',
  errFundMismatch: '兩次資金密碼不一致',
  viaPhone: '📱 手機短信',
  viaEmail: '✉️ 郵箱驗證',
  verifyPhone: '驗證綁定手機',
  verifyEmail: '驗證綁定郵箱',
  otp: '驗證碼',
  otpPh: '6 位驗證碼',
  sendOtp: '獲取驗證碼',
  otpSent: '驗證碼已發送',
  otpCd: '{n}s',
  otpWait: '{n}s 後重發',
  errOtp: '請輸入正確的驗證碼',
  fundNoBind:
    '⚠️ 你尚未綁定手機或郵箱,無法自助重置資金密碼。請先在「賬號安全」綁定手機或郵箱,或聯繫在線客服人工核身。',

  changePhone: '更換綁定手機',
  bindPhoneTitle: '綁定手機',
  stepVerifyPhone: '1 驗證當前手機',
  stepBindPhone: '2 綁定新手機',
  curPhone: '當前綁定手機',
  smsOtp: '短信驗證碼',
  smsOtpCurPh: '發送至當前手機',
  smsOtpNewPh: '發送至新手機',
  next: '下一步',
  newPhone: '新手機號',
  newPhonePh: '請輸入手機號',
  confirmBind: '確認更換',
  confirmBindFirst: '確認綁定',
  phoneHint1:
    '為保障賬戶安全,更換手機須先驗證當前手機;當前手機無法接收短信請聯繫在線客服人工核身。',
  phoneHint2: '更換成功後,驗證碼、安全通知將發送至新手機。',
  phoneOk: '手機號已更新',
  errPhone: '請輸入正確的手機號',
  errPhoneSame: '新手機號不得與當前相同',

  bindEmailTitle: '綁定郵箱',
  changeEmail: '更換綁定郵箱',
  stepVerifyEmail: '1 驗證當前郵箱',
  stepBindEmail: '2 綁定新郵箱',
  curEmail: '當前綁定郵箱',
  emailOtp: '郵箱驗證碼',
  emailOtpCurPh: '發送至當前郵箱',
  emailAddr: '郵箱地址',
  newEmailAddr: '新郵箱地址',
  emailPh: "name{'@'}example.com",
  emailHint1: '當前郵箱無法接收郵件?請聯繫在線客服人工核身。',
  emailHint2: '綁定後用於安全通知、賬戶找回;可隨時在此更換。',
  emailOk: '郵箱已更新',
  errEmail: '請輸入有效郵箱',
  errEmailSame: '新郵箱不得與當前相同',
}
